module.exports = __webpack_public_path__ + "static/cce_logo-30dcbb41a16ce648686f4a9e5c846d3e.png";